import Vue from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHandPointer, faRoute, faRotateLeft, faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { faSquare } from "@fortawesome/free-regular-svg-icons";

library.add(faHandPointer, faRoute, faSquare, faRotateLeft, faCaretDown, faCaretUp)
Vue.component('font-awesome-icon', FontAwesomeIcon)


// WEBPACK FOOTER //
// ./src/plugins/font-awesome.js